import { defineStore } from 'pinia'
// import get from 'lodash.get';

export const useDeviceStore = defineStore('device', {
  state: () => (
    {
      devices: null,
      models: null,
      addDevice: null,
      groups: [],
    }),
  getters: {
  },
  actions: {
    setDevices(devices) {
      this.devices = devices;
      this.updateGroups();
    },
    hasDevices() {
      return this.devices !== null;
    },
    setModels(models) {
      this.models = models;
    },
    hasModels() {
      return this.models !== null;
    },
    setAddDevice(device) {
      this.addDevice = device;
    },
    updateDevice(device) {
      const found = this.devices.find(d => {
        return d.deviceId === device.deviceId;
      });

      if (found) {
        this.devices = this.devices.map(o => {
          return o.deviceId === device.deviceId ? device : o;
        });
      }

      this.updateGroups();
    },
    deleteDevice(deviceId) {
      if (this.devices) {
        let found = this.devices.find(d => {return d.deviceId === deviceId });
        if (found) {
          this.devices.splice(this.devices.indexOf(found), 1);
        }
      }
      this.updateGroups();
    },
    updateGroups() {
      let groups = [];
      if (this.devices) {
        this.devices.forEach(d => {
          if (!groups.includes(d.group)) {
            groups.push(d.group);
          }
        });
      }

      this.groups = groups;
    },
    clearAddDevice() {
      this.addDevice = null;
    },
    hasAddDevice() {
      return this.addDevice !== null;
    }
  },
});
